<template>
  <el-card style="height: 710px; overflow-y: scroll">
    <div class="admin">
      <p>用户管理</p>
      <div class="form">
        <el-form :model="search_form">
          <el-form-item label="用户名称">
            <el-input
              placeholder="请输入"
              v-model="search_form.username"
              style="width: 80%"
            ></el-input>
          </el-form-item>
          <el-form-item label="使用状态">
            <el-select v-model="search_form.state" style="width: 80%">
              <el-option label="全部" value=""></el-option>
              <el-option label="使用中" value="1"></el-option>
              <el-option label="禁用中" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="get_user_data">查看</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="clear_form">清空</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button type="primary" class="add_button" @click="dialogVisible = true"
        >新增用户</el-button
      >
      <el-table
        border
        :data="tableData"
        :header-cell-style="{ 'background-color': '#f6f6f6' }"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          type="index"
          width="80px"
          label="序号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="username"
          label="用户名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="姓名"
        ></el-table-column>
        <el-table-column align="center" prop="sex" label="性别">
          <template slot-scope="scope">
            <span>{{ scope.row.sex === 1 ? "男" : "女" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="电话"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="unit"
          label="单位"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="department_mide"
          label="科室"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="groups"
          label="小组"
        ></el-table-column>
        <el-table-column align="center" prop="is_superuser" label="权限">
          <template slot-scope="scope">
            <span>{{ scope.row.is_superuser === 1 ? "管理" : "使用" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="is_active" label="使用状态">
          <template slot-scope="scope">
            <el-switch
              @change="change_switch(scope.row)"
              v-model="scope.row.is_active"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="reset_password(scope.row.id)"
              type="text"
              class=""
              >重置密码</el-button
            >
            <el-button @click="edit(scope.row)" type="text" class=""
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="current_page"
        layout="prev, pager, next"
        :page-size="page_size"
        hide-on-single-page
        @current-change="change_page"
        @prev-click="change_page"
        @next-click="change_page"
        :total="total"
      >
      </el-pagination>
      <el-dialog
        :modal="false"
        title="提示"
        class="dialog"
        :visible.sync="dialogVisible"
        :show-close="false"
        @close="dialog_close"
        width="30%"
      >
        <el-form :model="form" label-width="100px">
          <el-form-item label="用户名称">
            <el-input
              placeholder="请输入"
              style="width: 80%"
              v-model="form.username"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input
              placeholder="请输入"
              style="width: 80%"
              v-model="form.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input
              placeholder="请输入"
              style="width: 80%"
              v-model="form.phone"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-select style="width: 80%" v-model="form.sex">
              <el-option label="请选择" value=""></el-option>
              <el-option label="男" :value="1"></el-option>
              <el-option label="女" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用状态">
            <el-switch
              v-model="form.is_active"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="权限配置">
            <el-select style="width: 80%" v-model="form.is_superuser">
              <el-option label="请选择" value=""></el-option>
              <el-option label="管理权限" :value="1"></el-option>
              <el-option label="使用权限" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户单位">
            <el-select
              filterable
              default-first-option
              style="width: 80%"
              v-model="form.unit"
            >
              <el-option label="请选择" value=""></el-option>
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in unit"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户科室">
            <el-select
              filterable
              allow-create
              default-first-option
              style="width: 80%"
              v-model="form.department_mide"
            >
              <el-option label="请选择" value=""></el-option>
              <el-option
                :label="item.name"
                :value="item.name"
                v-for="(item, index) in department_mide"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户分组">
            <el-select
              filterable
              allow-create
              default-first-option
              style="width: 80%"
              v-model="form.groups"
            >
              <el-option label="请选择" value=""></el-option>
              <el-option
                :label="item.name"
                :value="item.name"
                v-for="(item, index) in group"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="到期时间">
            <el-date-picker
              style="width: 80%"
              v-model="form.become_due_time"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="平台配置">
            <el-select multiple style="width: 80%" v-model="form.access">
              <el-option label="网页" :value="0"></el-option>
              <el-option label="小程序" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="buttons">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submit">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </el-card>
</template>
<script>
import request from "@/utils/request";

export default {
  name: "WizardView",
  data: function () {
    return {
      tableData: [],
      page: 1,
      page_size: 10,
      total: 0,
      current_page: 1,
      search_form: {
        username: "",
        state: "",
      },
      form: {
        username: "",
        is_active: true,
        is_superuser: "",
        groups: "",
        department_mide: "",
        unit: "",
        phone: "",
        sex: "",
        name: "",
        become_due_time: "",
        access: [],
      },
      dialogVisible: false,
      group: [],
      department_mide: [],
      unit: [],
    };
  },
  methods: {
    get_user_data() {
      request
        .get("/admin/user", {
          params: {
            page: this.page,
            page_size: this.page_size,
            username: this.search_form.username,
            state: this.search_form.state,
          },
        })
        .then((data) => {
          if (data["code"] === 200) {
            this.tableData = data["data"];
            this.total = data["count"];
          }
        });
    },
    clear_form() {
      this.search_form = {
        username: "",
        state: "",
      };
      this.get_user_data();
    },
    dialog_close() {
      this.form = {
        username: "",
        is_active: true,
        is_superuser: "",
        groups: "",
        department_mide: "",
        unit: "",
        phone: "",
        sex: "",
        name: "",
        become_due_time: "",
        access: [],
      };
      this.dialogVisible = false;
    },
    submit() {
      request.post("/admin/user", this.form).then((data) => {
        if (data["code"] === 200) {
          this.$message.success(data["message"]);
          this.get_user_data();
          this.dialogVisible = false;
        } else {
          this.$message.error(data["error"]);
        }
      });
    },
    edit(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    change_switch(row) {
      this.form = row;
      this.submit();
    },
    reset_password(id) {
      request.put(`/admin/user?id=${id}`).then((data) => {
        if (data["code"] === 200) {
          this.$message.success("密码重置成功！");
        } else {
          this.$message.error(data["error"]);
        }
      });
    },
    change_page(page) {
      this.page = page;
      this.get_user_data();
    },
    get_group_data() {
      request.get("/admin/group").then((data) => {
        if (data["code"] === 200) {
          this.group = data["data"];
        }
      });
    },
    get_unit_data() {
      request.get("/admin/unit",{
        params: {
          page: 1,
          page_size: 1000,
        }
      }).then((data) => {
        if (data["code"] === 200) {
          this.unit = data["data"];
        }
      });
    },
    get_department_mide_data() {
      request.get("/admin/department/mide").then((data) => {
        if (data["code"] === 200) {
          this.department_mide = data["data"];
        }
      });
    },
  },
  created() {
    this.get_user_data();
    this.get_group_data();
    this.get_unit_data();
    this.get_department_mide_data();
  },
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.admin {
  .form > form {
    display: flex;
    align-items: flex-end;

    .el-form-item {
      width: 25%;
    }

    .el-form-item:nth-child(3),
    .el-form-item:nth-child(4) {
      width: auto;
      margin-right: 15px;
    }
  }

  .add_button {
    margin-bottom: 20px;
  }

  .button {
    margin-right: 15px;
    font-size: 15px;
    cursor: pointer;
    color: #007bff;
  }

  .dialog {
    .buttons {
      margin-top: 45px;
      display: flex;
      justify-content: flex-end;
    }
  }
}

.el-card {
  width: 99%;
}
</style>
